import React, { createContext, useContext } from 'react';

export interface EmailPrefill {
  to?: string[];
  subject?: string;
  body?: string;
}

export interface CallPrefill {
  phoneNumber?: string;
  contactLabel?: string;
}

interface MatterActionsContextType {
  openEmailModal: (prefill?: EmailPrefill) => void;
  openCallModal: (prefill?: CallPrefill) => void;
}

const MatterActionsContext = createContext<MatterActionsContextType | null>(
  null,
);

interface MatterActionsProviderProps {
  children: React.ReactNode;
  openEmailModal: (prefill?: EmailPrefill) => void;
  openCallModal: (prefill?: CallPrefill) => void;
}

export const MatterActionsProvider: React.FC<MatterActionsProviderProps> = ({
  children,
  openEmailModal,
  openCallModal,
}) => {
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value: MatterActionsContextType = {
    openEmailModal,
    openCallModal,
  };

  return (
    <MatterActionsContext.Provider value={value}>
      {children}
    </MatterActionsContext.Provider>
  );
};

export const useMatterActions = (): MatterActionsContextType => {
  const context = useContext(MatterActionsContext);
  if (!context) {
    throw new Error(
      'useMatterActions must be used within a MatterActionsProvider',
    );
  }
  return context;
};

// Safe hook that returns null if context is not available (for optional usage)
export const useMatterActionsOptional = (): MatterActionsContextType | null => {
  return useContext(MatterActionsContext);
};
